import * as types from '../constants'

const index = {
  pending: `${types.UPDATE_CUSTOMER}_PENDING`,
  fulfilled: `${types.UPDATE_CUSTOMER}_FULFILLED`,
  rejected: `${types.UPDATE_CUSTOMER}_REJECTED`
}

export const updateCustomer = {
  [index.pending]: ({ draft }) => {
    draft.saveCustomersLoading = true
    draft.error = null
  },
  [index.fulfilled]: ({ draft, action }) => {
    draft.customer = action.payload.updated
    draft.saveCustomersLoading = false
    draft.error = null
  },
  [index.rejected]: ({ draft, action }) => {
    draft.saveCustomersLoading = false
    draft.error = action.payload
  }
}
